import { useState } from "react";
import { useApp } from "../store.jsx";
import { api } from "../api.js";

// Collapsible list of archived (soft-deleted) tasks for one department, each
// with a Restore button. Lazy-loads on expand; archived tasks aren't in the
// main store fetch.
export default function ArchivedTasks({ dept }) {
  const { restoreTask } = useApp();
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);

  async function load() {
    setErr(null);
    try {
      const all = await api.listArchivedTasks();
      setRows(all.filter(t => t.deptShort === dept));
    } catch (e) { setErr(e); setRows([]); }
  }

  function toggle() {
    const next = !open;
    setOpen(next);
    if (next && rows === null) load();
  }

  async function onRestore(id) {
    await restoreTask(id);
    setRows(prev => prev && prev.filter(t => t.id !== id));
  }

  return (
    <section className="brief" style={{marginTop:18}}>
      <button className="btn" onClick={toggle}>
        {open ? "▾" : "▸"} Archived tasks{rows ? ` (${rows.length})` : ""}
      </button>
      {open && (
        <>
          {err && <div className="sub" style={{marginTop:10, color:"#fca5a5"}}>Failed to load archived tasks.</div>}
          {rows === null && <div className="sub" style={{marginTop:10}}>Loading…</div>}
          {rows && rows.length === 0 && <div className="sub" style={{marginTop:10}}>No archived tasks for {dept}.</div>}
          {rows && rows.length > 0 && (
            <ul className="archived-list">
              {rows.map(t => (
                <li key={t.id}>
                  <span>#{t.briefNo} · {t.title}</span>
                  <button className="btn" onClick={() => onRestore(t.id)}>Restore</button>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </section>
  );
}
